import { useId } from 'react'
import { cn } from '@/shared/lib'

// Переключатель среза списка: один вариант из нескольких. Радиогруппа, а не
// табы — контент экрана тот же, меняется только выборка. Presentational:
// значение и смена — снаружи (страница синхронит со search-param).

export interface SegmentedOption<V extends string> {
  value: V
  label: string
}

interface SegmentedProps<V extends string> {
  options: SegmentedOption<V>[]
  value: V
  onChange: (value: V) => void
  className?: string
  /** Название группы — уходит в скрытый legend. */
  label: string
}

export function Segmented<V extends string>({
  options,
  value,
  onChange,
  className,
  label,
}: SegmentedProps<V>) {
  const name = useId()
  return (
    <fieldset
      className={cn('inline-flex items-center gap-1 rounded-pill bg-bg-elevated p-1', className)}
    >
      <legend className="sr-only">{label}</legend>
      {options.map((option) => {
        const active = option.value === value
        return (
          <label
            key={option.value}
            className={cn(
              'relative cursor-pointer rounded-pill px-3 py-1 text-sm transition-colors focus-within:ring-2 focus-within:ring-border-accent',
              active
                ? 'bg-bg-surface text-text-primary'
                : 'text-text-secondary hover:text-text-primary',
            )}
          >
            {/* Радио растянуто по кнопке и прозрачно: клик попадает в сам input,
                а не только в подпись; семантика остаётся нативной. */}
            <input
              type="radio"
              name={name}
              value={option.value}
              checked={active}
              onChange={() => onChange(option.value)}
              className="absolute inset-0 m-0 cursor-pointer appearance-none opacity-0"
            />
            {option.label}
          </label>
        )
      })}
    </fieldset>
  )
}
